import { Component } from '@angular/core';

@Component({
  templateUrl: '../../../../../../assets/images/toastError.svg',
})
export class ToastErrorComponent { }
